import script from "./OrderCompletPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderCompletPage.vue?vue&type=script&setup=true&lang=js"

import "./OrderCompletPage.vue?vue&type=style&index=0&id=6a7b0786&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a7b0786"]])

export default __exports__